import React, { useState } from 'react';
import moment from 'moment-timezone';
import { Button, DatePicker, Input, Modal } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import { DATE_DAILY_FORMAT } from '../../constants/date';
import ConfirmationModal from '../common/ConfirmationModal';

const { RangePicker } = DatePicker;
const { TextArea } = Input;

const UpdateLabelModalRowContainer = ({ children }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '15px',
    }}
  >
    {children}
  </div>
);

const UpdateLabelModal = ({
  id,
  title,
  description,
  duration,
  saving,
  hasPermission,
  onClose,
  onSave,
  onDelete,
  onTitleChange,
  onDescriptionChange,
  onDurationChange,
}) => {
  const [showModal, setShowModal] = useState(false);

  return showModal ? (
    <ConfirmationModal
      showModal={showModal}
      setShowModal={setShowModal}
      onExec={() => onDelete(id)}
    >
      <div>
        Are you sure to permanently delete <span style={{ fontWeight: 'bold' }}>{` ${title}`}</span>{' '}
        ?
      </div>
    </ConfirmationModal>
  ) : (
    <Modal
      title={`${id ? 'Edit' : 'New'} label`}
      onCancel={onClose}
      footer={
        <UpdateLabelModalRowContainer>
          {id && (
            <Button
              icon={<DeleteOutlined />}
              disabled={!hasPermission}
              onClick={() => setShowModal(!showModal)}
            />
          )}
          <div style={{ marginLeft: 'auto' }}>
            <Button
              key="submit"
              type="primary"
              loading={saving}
              disabled={!hasPermission || !title}
              onClick={() => onSave(id)}
            >
              Save
            </Button>
            <Button key="back" onClick={onClose}>
              Cancel
            </Button>
          </div>
        </UpdateLabelModalRowContainer>
      }
      open
    >
      <UpdateLabelModalRowContainer>
        <span style={{ flex: 1 }}>Title:</span>
        <Input
          value={title}
          placeholder="Label title"
          className="ant-input-border-bottom"
          style={{ flex: 3 }}
          onChange={(e) => onTitleChange(e.target.value)}
        />
      </UpdateLabelModalRowContainer>
      <UpdateLabelModalRowContainer>
        <span style={{ flex: 1 }}>Description:</span>
        <TextArea
          value={description}
          placeholder="Label description"
          className="ant-input-border-bottom"
          style={{ flex: 3 }}
          autoSize={{ minRows: 1, maxRows: 7 }}
          onChange={(e) => onDescriptionChange(e.target.value)}
        />
      </UpdateLabelModalRowContainer>
      <UpdateLabelModalRowContainer>
        <span style={{ flex: 1 }}>Duration:</span>
        <RangePicker
          value={[moment(duration.at(0)), moment(duration.at(-1))]}
          onChange={([from, to]) =>
            onDurationChange([from.format(DATE_DAILY_FORMAT), to.format(DATE_DAILY_FORMAT)])
          }
          allowClear={false}
          className="date-selector-borderless"
          style={{ flex: 3 }}
        />
      </UpdateLabelModalRowContainer>
    </Modal>
  );
};

export default UpdateLabelModal;
